var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FDDD59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3432 18.2608C7.07708 17.9272 7.28948 17.5809 7.74588 17.5836C10.9341 17.603 14.1225 17.5996 17.3107 17.5879C17.795 17.5861 17.9134 17.7191 17.867 18.1476C17.7903 18.3163 17.6556 18.3549 17.4783 18.3548C14.1903 18.3508 10.9022 18.3521 7.61417 18.3508C7.51664 18.3507 7.40132 18.3867 7.3432 18.2608Z",
    fill: "#6F5901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66774 12.5764C6.51378 12.2881 6.3047 12.0302 6.32289 11.6655C6.3475 11.1741 6.53518 10.7993 6.96866 10.5539C7.41515 10.3011 7.8524 10.3406 8.28769 10.5825C8.45206 10.6738 8.56079 10.8219 8.68423 10.9555C8.98284 11.3533 8.99005 11.9234 8.70112 12.3034C8.69414 12.3193 8.69037 12.3359 8.68975 12.3532C8.40645 13.0576 7.12577 13.1935 6.66774 12.5764Z",
    fill: "#705A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6291 12.5946L16.3579 12.1886C16.0406 11.7208 16.1974 11.2909 16.4646 10.8707C16.72 10.4689 17.2832 10.2555 17.7552 10.3805C18.086 10.5033 18.4043 10.6449 18.611 10.9531C18.7954 11.0847 18.8025 11.296 18.8117 11.4835C18.8304 11.8646 18.8229 12.2507 18.484 12.5252L18.4846 12.5238C18.4441 12.7374 18.2424 12.7714 18.0952 12.8499C17.6198 13.1034 16.8918 12.9853 16.6291 12.5946Z",
    fill: "#705A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/regular.1589f1b9a22ba7b3d04ec4e7755e8d33.svg";
export { ForwardRef as ReactComponent };